import { ReactComponent as MmSvg } from "../images/mm.svg";
import { SvgIcon } from "@mui/material";
import _ from "lodash";

const SUBWAY_DICT = [
    {
        name: 'Белорусская',
        color: '#2DBE2C',
        priority: 1
    },
    {
        name: 'Крестьянская застава',
        color: '#2DBE2C',
        priority: 2
    },
    {
        name: 'Медведково',
        color: '#ED9121',
        priority: 3
    },
    {
        name: 'Лухмановская',
        color: '#DE64A1',
        priority: 3
    },
    {
        name: 'Ховрино',
        color: '#2DBE2C',
        priority: 3
    }
]

export const extractSubway = (address) => {
    // г. Москва ул. Пятницкая д. 23 (м. Крестьянская застава (3 мин))

    const fullName = _.head(address.match(/(?<=\(м\.\s)(.+)(?=\))/, ));
    const name = _.head(address.match(/(?<=\(м\.\s)(.+?)(?=\s\(|\))/, ));


    const color = _.get(_.find(SUBWAY_DICT, { name: name }), "color");

    return {
        icon: <SvgIcon component={MmSvg} inheritViewBox fontSize="4px" sx={{ verticalAlign: "middle", color }} />,
        name: name,
        fullName: fullName
    };
}

export const clearSubway = (address) => {

}

/**
 * @param subwayList list of strings representing addresses with nearest subway station
 * @returns array of objects sorted by priority in ascending order
 */
export const groupSubway = (subwayList) => {
    return _.map(_.sortBy(_.uniqBy(subwayList, 'name'), 'priority'), loc => extractSubway(loc));
}
